import React from 'react';

export const useFilter = ({ selectedFilters, setSelectedFilters }) => {
  const add = React.useCallback(
    filter => {
      setSelectedFilters([...selectedFilters, filter]);
    },
    [selectedFilters, setSelectedFilters]
  );

  const remove = React.useCallback(
    filter => {
      setSelectedFilters(selectedFilters.filter(f => f !== filter));
    },
    [selectedFilters, setSelectedFilters]
  );

  const clear = React.useCallback(() => {
    setSelectedFilters([]);
  }, [setSelectedFilters]);

  return {
    add,
    remove,
    clear,
  };
};
